<template>
    <div>
        <div v-if="isSupplier" :style="{ visibility: loadingOffers ? 'hidden' : 'unset' }" class="total-results">
            {{ offersTotal }} resultados
        </div>
        <div v-if="loadingOffers" class="loading-offers">
            <HalfCircleSpinner
                :animation-duration="1000"
                :size="70"
                color="#4285f4"
                class="preloader-wrapper animated fast fadeIn fadeOut"
            />
        </div>
        <div class="cards-box">
            <CardOffer
                v-for="offer in offers"
                :key="offer.id"
                :data="offer"
                :isSupplier="isSupplier"
                :subscription="subscription"
                class="offer-card"
                @remove-opportunity="$emit('remove-opportunity', $event)"
            ></CardOffer>
            <div
                v-for="index in dummyCards"
                :key="index"
                style="visibility: hidden"
                class="competition_data-card-component offer-card"
            ></div>
        </div>
        <div v-if="offers.length == 0 && !loadingOffers" class="center-align">
            Nenhuma cotação está no painel no momento.
        </div>
        <div v-if="loadingMoreOffers" class="loading-offers">
            <HalfCircleSpinner
                :animation-duration="1000"
                :size="70"
                color="#4285f4"
                class="preloader-wrapper animated fast fadeIn fadeOut"
            />
        </div>
    </div>
</template>

<script>
import CardOffer from '@/components/supplier/competition-dashboard/card-offer/';
import { HalfCircleSpinner } from 'epic-spinners';
export default {
    name: 'CompetitionSystem',
    components: { CardOffer, HalfCircleSpinner },
    props: {
        isSupplier: Boolean,
        offersTotal: Number,
        loadingOffers: Boolean,
        loadingMoreOffers: Boolean,
        subscription: Object,
        offers: Array,
        dummyCards: Number,
    },
};
</script>
<style>
.total-results {
    font-size: 14px;
    line-height: 19px;
    color: #707070;
    text-align: right;
    margin-bottom: 20px;
    margin-top: 15px;
}
</style>
